import fxBigScreenContainer from '../packages/fxBigScreenContainer/index' //大屏容器
import fxFullScreenContainer from '../packages/fxFullScreenContainer/index' //全屏容器

import fxHeader1 from '../packages/fxHeader1/index'

//fxecharts
import fxChart from '../packages/fxChart/index'
import fxChartBar from '../packages/fxChartBar/index'
import fxChartPie from '../packages/fxChartPie/index'
import fxChartLine from '../packages/fxChartLine/index'
import fxChartGauge from '../packages/fxChartGauge/index'
import fxChartLiquidFill from '../packages/fxChartLiquidFill/index'

import fxMap from '../packages/fxMap/index'
import fxBmap from '../packages/fxBmap/index'
import fxBmap1 from '../packages/fxBmap1/index'





//border
import fxBorderBox1 from '../packages/fxBorderBox1/index'                       //
import fxBorderBox2 from '../packages/fxBorderBox2/index'                      //
import fxBorderBox3 from '../packages/fxBorderBox3/index'                       //
import fxBorderBox4 from '../packages/fxBorderBox4/index'                       //
import fxBorderBox5 from '../packages/fxBorderBox5/index'                       //
import fxBorderBox6 from '../packages/fxBorderBox6/index'                       //
import fxBorderBox7 from '../packages/fxBorderBox7/index'                       //
import fxBorderBox8 from '../packages/fxBorderBox8/index'                       //
import fxBorderBox9 from '../packages/fxBorderBox9/index'                       //
import fxBorderBox10 from '../packages/fxBorderBox10/index'                       //
import fxBorderBox11 from '../packages/fxBorderBox11/index'                       //
import fxBorderBox12 from '../packages/fxBorderBox12/index'                       //
import fxBorderBox13 from '../packages/fxBorderBox13/index'                       //

// decoration
import fxDecoration1 from '../packages/fxDecoration1/index'                       //
import fxDecoration2 from '../packages/fxDecoration2/index'                       //
import fxDecoration3 from '../packages/fxDecoration3/index'                       //
import fxDecoration4 from '../packages/fxDecoration4/index'                       //
import fxDecoration5 from '../packages/fxDecoration5/index'                       //
import fxDecoration6 from '../packages/fxDecoration6/index'                       //
import fxDecoration7 from '../packages/fxDecoration7/index'                       //
import fxDecoration8 from '../packages/fxDecoration8/index'                       //
import fxDecoration9 from '../packages/fxDecoration9/index'                       //
import fxDecoration10 from '../packages/fxDecoration10/index'                       //
import fxDecoration11 from '../packages/fxDecoration11/index'                       //

// loading
import fxLoading1 from '../packages/fxLoading1/index'                       //

// fxDigitalFlop
import fxDigitalFlop from '../packages/fxDigitalFlop/index'                       //fxDigitalFlop
import fxDigitalList from '../packages/fxDigitalList/index'  

// fxScrollBoard
import fxScrollBoard from '../packages/fxScrollBoard/index'                       //fxScrollBoard

// fxScrollRankingBoard
import fxScrollRankingBoard from '../packages/fxScrollRankingBoard/index'


import { getMapScript } from '../src/util/index'

const components = [
  fxBigScreenContainer,
  fxFullScreenContainer,
  fxHeader1,

  fxChart,
  fxChartBar,  //条形图
  fxChartPie,  //饼图
  fxChartLine, //折线图
  fxChartGauge,//仪表盘
  fxChartLiquidFill,//水波球

  fxMap,
  fxBmap,
  fxBmap1,

  fxBorderBox1,
  fxBorderBox2,
  fxBorderBox3,
  fxBorderBox4,
  fxBorderBox5,
  fxBorderBox6,
  fxBorderBox7,
  fxBorderBox8,
  fxBorderBox9,
  fxBorderBox10,
  fxBorderBox11,
  fxBorderBox12,
  fxBorderBox13,

  fxDecoration1,
  fxDecoration2,
  fxDecoration3,
  fxDecoration4,
  fxDecoration5,
  fxDecoration6,
  fxDecoration7,
  fxDecoration8,
  fxDecoration9,
  fxDecoration10,
  fxDecoration11,

  fxLoading1,

  fxDigitalFlop,
  fxDigitalList,

  fxScrollBoard,

  fxScrollRankingBoard,
]

const install = function (Vue, option) {
  if (install.installed) return
  install.installed = true
  const { ak } = option || ""
  if (ak) getMapScript({ ak })

  // Vue.prototype._BMap = () => ({ ak })

  components.map(component => {
    Vue.component(component.name, component)
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  // window.Vue.use(install)
  install(window.Vue)
}

export default {
  install,
  ...components
}
